import * as Action from "../action/sys_mgt_user.action"


const initState = {
    userList: [],  // 用户列表
    totalCount: 0, // 总数
    isLoading: false, // 是否加载中
    userModal: {  // 用户模态框
        visible: false,
        title: "",
        isLoading: false,
        info: {}
    },
    searchParams: { // 查询参数
        pageSize:10,
        pageNumber: 1,
    },
    resetPasswordModal: { // 重置密码模态框
        isLoading: false,
        visible: false,
        userNo: "",
        username: "",
    }
}

/**
 * 用户reducer
 */
const userReducer =  (state = initState, action) => {
    switch (action.type) {
        case Action.SYS_MGT_USER_LIST:
            return {...state, userList: action.userList, totalCount: action.totalCount}
        case Action.SYS_MGT_USER_MODAL:
            return {...state, userModal: action.userModal}
        case Action.SYS_MGT_USER_LIST_IS_LOADING: return {...state, isLoading: action.isLoading} // 用户列表loading
        case Action.SYS_MGT_USER_MODAL_IS_LOADING: return {...state, userModal: {...state.userModal, isLoading: action.isLoading}} // 用户表单是否提交中
        case Action.SYS_MGT_USER_EDIT_USER: // 编辑用户
            const newList = state.userList.map(user => {
                if(user.userNo == action.userInfo.userNo){
                    return {
                        ...user,
                        ...action.userInfo
                    }
                }
                return user;
            });
            return {
                ...state,
                userList: newList
            }
        case Action.SYS_MGT_DEPT_SET_SEARCH_PARAMS: //设置查询参数
            return {
                ...state,
                searchParams: action.searchParams
            }
        case Action.SYS_MGT_USER_RESET_PASSWORD_MODAL: // 重置密码模态框信息
            return {
                ...state,
                resetPasswordModal: {
                    ...state.resetPasswordModal,
                    ...action.data
                }
            }
        default: return {...state}
    }
}

export default userReducer;
